
<div>
    <app-bar :title="t('workouts_title')"></app-bar>

    <v-layout>
        <workout-collection></workout-collection>
    </v-layout>
</div>
